export interface ExampleServer {
  label: string;
  url: string;
  expectation: string;
}

// Public MCP servers that each land on a different branch of the probe, so the
// page is useful before anyone has an address of their own to paste.
export const EXAMPLE_SERVERS: ExampleServer[] = [
  {
    label: 'Notion',
    url: 'https://mcp.notion.com/mcp',
    expectation: 'Connects with nothing typed in',
  },
  {
    label: 'Atlassian',
    url: 'https://mcp.atlassian.com/v1/sse',
    expectation: 'Registers a client on demand',
  },
  {
    label: 'GitHub Copilot',
    url: 'https://api.githubcopilot.com/mcp/',
    expectation: 'Needs a client registered by hand',
  },
  {
    label: 'Figma',
    url: 'https://mcp.figma.com/mcp',
    expectation: 'Offers registration, then refuses ours',
  },
];
